import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Form } from 'tmt-ui-kit';

import { convertPriceDetail as convert } from '~/utils/price';

const CrossingPrice = styled.span`
  color: ${props => props.theme.blueGrayDarker};
  text-decoration: line-through;
`;

const priceConverter = (currency, rates) => price => convert(price, currency, rates);

const MultiTierSelector = props => {
  const { selectedMultiTier, rates, currency, onChangeSubTierQuantity } = props;
  const convertPrice = priceConverter(currency, rates);
  return (
    <div>
      <Form.RadioButton
        onChange={value => props.onChangeTier(value)}
        values={
          selectedMultiTier
            .map((tier) => ({
              value: tier.tier,
              label: <span>{tier.tier}</span>,
              childRender: () => (
                <div>
                  {tier.sub_tiers.map((subTier, subIndex) => {
                    const displayPrice = subTier.display_price || 0;
                    const { price } = subTier;
                    return (
                      <Form.QuantityInput
                        key={subTier.name}
                        min={0}
                        max={12}
                        value={subTier.quantity}
                        label={subTier.name}
                        subLabel={<span>{displayPrice > 0 && <CrossingPrice>{currency} {convertPrice(displayPrice)} </CrossingPrice>}{currency} {convertPrice(price)}</span>}
                        onChangeCounter={value => onChangeSubTierQuantity(subIndex, value)}
                      />
                    );
                  })}
                </div>
              ),
              active: tier.active
            }))
        }
      />
    </div>
  );
};

MultiTierSelector.propTypes = {
  onChangeTier: PropTypes.func,
  onChangeSubTierQuantity: PropTypes.func,
  selectedMultiTier: PropTypes.array,
  rates: PropTypes.object,
  currency: PropTypes.string,
};

export default MultiTierSelector;
